import { combineReducers } from 'redux'
import app from './app-reducer'

const combinedReducers = combineReducers({
  app,
})

export default combinedReducers
